<div class="triangulo-redondeado-container">
    <img class="triangulo-redondeado-img" src="/assets/images/cliniweb/cola-globo-dialogo.svg" alt="cola-globo-dialogo" />
    <div class="triangulo-redondeado-border-top"></div>
</div>